import { useEffect } from "react";

export default function Notification({ message, type, onClose }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => onClose(), 3000);
    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  const bg =
    type === "error"
      ? "#b00020"
      : "linear-gradient(135deg, #d1b97a, #b8860b)";

  return (
    <div
      style={{
        position: "fixed",
        bottom: 30,
        right: 30,
        background: bg,
        color: type === "error" ? "#fff" : "#111",
        padding: "12px 20px",
        borderRadius: 8,
        fontSize: 14,
        fontWeight: 600,
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        zIndex: 9999,
        transition: "all 0.3s ease",
        minWidth: 200,
      }}
    >
      {message}
    </div>
  );
}
